module.exports = __webpack_public_path__ + "static/media/WMATIC.040f1bcd.svg";